import { create } from 'zustand';

interface CheckoutState {
  /** Address picked on Daftar Alamat for the checkout; null = the main address */
  addressId: string | null;
  setAddressId: (addressId: string | null) => void;
}

// Screen state only (not persisted): a reload falls back to the main address
export const useCheckoutStore = create<CheckoutState>((set) => ({
  addressId: null,
  setAddressId: (addressId) => set({ addressId }),
}));
